import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { ConnectionService } from '../../connection.service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { NgForm } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-votes',
  templateUrl: './votes.component.html',
  styleUrls: ['./votes.component.css']
})
export class VotesComponent implements OnInit {
  listSR: any; proRes = []; vote_address: any = {}; vote_count = []; sraddress; amtval; setAdd; tot: number = 1; token = localStorage.getItem('Sastana_Token'); modalRef: BsModalRef; signLoader = false;
  @ViewChild('beforeLogin') beforeLogin: TemplateRef<any>;
  @ViewChild('srForm') srForm: TemplateRef<any>;
  timeString: string = '';

  userAddress = localStorage.getItem('Address')
  freezeAmount: any;
  srDetailsList: any;
  srCounts: any;
  nextRound: any;
  order = -1
  listVoting: any;
  totalVotes: number;

  constructor(private conn: ConnectionService, private modalService: BsModalService, private alert: ToastrService, private spinner: NgxSpinnerService) { 
      this.getnextmaintenancetime()
  }

  ngOnInit() {
    
    this.getSR();
    this.getFreeze();
    this.Srdetails(this.order);
    this.SrInfo();

    setTimeout(() => {
      this.calculateTimeRemaining();
    }, 3000);

  }



  getSR() {
    this.conn.postUrl('vote/votingList', {}).subscribe((res: any) => {
      this.listVoting = res.data;
    });
    this.conn.clearbackground();
  }

  sendModal() {
    this.modalRef = this.modalService.show(this.srForm);
  }

  loginModal() {
    this.modalRef = this.modalService.show(this.beforeLogin);
  }

  SRFunc(address) {

    let obj = {
      "fromAddress": this.userAddress,
      "srAddress": address,
      "voteCount": this.amtval
    }
    this.spinner.show()
    if (this.amtval != undefined) {
      if (this.freezeAmount != 0) {
        this.conn.postUrl('vote/voting', obj).subscribe((res: any) => {
          this.proRes = res.result;
          if (res.success == true) {
            this.alert.success(res.msg);
            this.spinner.hide()
            setTimeout(() => {
              window.location.reload()
            }, 1000)
          } else {
            this.alert.error(res.msg);
            this.spinner.hide()
          }
          this.sraddress = ''
        })
      }
      else {
        this.spinner.hide()
        this.alert.error('Insufficient voting power');
      }
    }
    else {
      this.spinner.hide()
      this.alert.error('Vote Count cannot be 0');
    }
  }


  getFreeze() {
    this.conn.postUrl('vote/getFreezeAmount', { address: this.userAddress }).subscribe((res: any) => {
      if (res.success == true) {
        this.freezeAmount = res.data.freezeamount
      }
      else {
        this.freezeAmount = 0
      }
    })
  }

  sortorder(order) {
    this.Srdetails(order)
  }

  Srdetails(order) {
    this.conn.getUsers('superRep/getAllWitness', 'sortOrder', order).subscribe((res: any) => {
      if (res.status == true) {
        this.srDetailsList = res.data;
        var sum = 0
        for (let i = 0; i < this.srDetailsList.length; i++ ) {
          sum += this.srDetailsList[i].voteCount;
        }
        this.totalVotes = sum
      }
    });
  }

  voteList(address, event) {
    this.vote_address[address] = event;
  }

  setVal(type, address) {
    this.setAdd = address;
    var inputValue = (document.getElementById(address) as HTMLInputElement);

    if (type == 'inc') {
      if (+inputValue.value > 0) {
        this.amtval = +inputValue.value;
      } else {
        this.amtval = 0;
      }
      this.amtval = parseInt(this.amtval) + 1;
      inputValue.value = this.amtval;
    } else {
      this.amtval = inputValue.value;
      this.amtval = parseInt(this.amtval) - 1;
      if (this.amtval > 0) {
        inputValue.value = this.amtval;
      }
    }
  }

  SrInfo() {
    this.conn.getUrl('superRep/getSrDetails').subscribe((res: any) => {
      this.srCounts = res.data[0];
    });
  }

  getnextmaintenancetime() {
    // this.spinner.show()
    this.conn.postUrl('contract/getTime', {}).subscribe((res: any) => {
      // this.spinner.hide()
      this.nextRound = res.data
    });
  }

  calculateTimeRemaining() {
    const currentTime = new Date().getTime();
    const timeDifference = this.nextRound - currentTime 
    if (timeDifference > 0) {
      const hours = Math.floor((timeDifference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((timeDifference % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((timeDifference % (1000 * 60)) / 1000);
      this.timeString = `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
      setTimeout(() => {
        this.calculateTimeRemaining();
      }, 1000);
    } else {
      // this.timeString = 'Timer expired!';
    }
  }

  copyText(val: string) {
    let selBox = document.createElement('input');
    selBox.value = val;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
    this.alert.success('Copied to the clipboard');
  }
}
